// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"copy-link__link--1gBUk","icon":"copy-link__icon--3MCha","wrapper":"copy-link__wrapper--IKvq6","text":"copy-link__text--36CIm"};